import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Loader } from './Loader';
import { Stack } from './Stack';
export function FullScreenLoader(props) {
    return (_jsx(Stack, { align: "center", justify: "center", className: "h-screen", width: "full", children: _jsx(Loader, Object.assign({}, props)) }));
}
